import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { hasPermission } from '../../../store/apiWrapper';
import { searchActions } from '../../../store/searchStore';
import { windowActions } from '../../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import SearchTip from '../../common/searchTip';
import TabLink from '../tabLink';

import PropertySkOwnerSearchForm from './searchForms/propertySkOwnerSearchForm';
import PropertySkOwnershipDeedSearchForm from './searchForms/propertySkOwnershipDeedSearchForm';
import PropertySkRegistrationNumberSearchForm from './searchForms/propertySkRegistrationNumberSearchForm';
import PropertySkParcelSearchForm from './searchForms/propertySkParcelSearchForm';
import PropertySkFlatOrNonFlatAreaSearchForm from './searchForms/propertySkFlatOrNonFlatAreaSearchForm';

import IconOwner from '../../../img/icons/BBiconsNemovitostiVlastnik';
import IconOwnershipDeed from '../../../img/icons/BBiconsNemovitostiCisloListuVlastnictvi';
import IconRegistrationNumber from '../../../img/icons/BBiconsNemovitostiPopisneCislo';
import IconParcel from '../../../img/icons/BBiconsNemovitostiParcela';
import IconFlatOrNonFlatArea from '../../../img/icons/BBiconsNemovitostiByt';
import FormMenuControl from '../../common/formMenuControl'

const searchType = {
    owner: "owner",
    ownershipDeed: "ownership-deed",
    registrationNumber: "registration-number",
    parcel: "parcel",
    flatOrNonFlatArea: "flat-or-non-flat-area"
};

class PropertySkSearchForm extends React.Component {
    state = {
        selected: searchType.owner
    };

    render() {
        return (
            <div className="columns is-desktop">
                <div className="column is-4-desktop tabs tabs-form-menu" style={{ fontSize: "1em" }}>
                    <FormMenuControl>
                        <ul>
                            <TabLink type={searchType.owner} selected={this.state.selected} onSelect={this.selectSearch} icon={<IconOwner className="tabs-icon" />}
                                titleKey={this.getTabLinkTranslationKey(searchType.owner)} descriptionKey={this.getTabLinkDescriptionTranslationKey(searchType.owner)} hr={true}
                            />
                            {hasPermission(null, "SearchCadastreSkAdvanced") && <>
                                <TabLink type={searchType.ownershipDeed} selected={this.state.selected} onSelect={this.selectSearch} icon={<IconOwnershipDeed className="tabs-icon" />}
                                    titleKey={this.getTabLinkTranslationKey(searchType.ownershipDeed)}
                                    descriptionKey={this.getTabLinkDescriptionTranslationKey(searchType.ownershipDeed)} hr={true}
                                />
                                <TabLink type={searchType.registrationNumber} selected={this.state.selected} onSelect={this.selectSearch}
                                    icon={<IconRegistrationNumber className="tabs-icon" />}
                                    titleKey={this.getTabLinkTranslationKey(searchType.registrationNumber)}
                                    descriptionKey={this.getTabLinkDescriptionTranslationKey(searchType.registrationNumber)} hr={true}
                                />
                                <TabLink type={searchType.parcel} selected={this.state.selected} onSelect={this.selectSearch}
                                    icon={<IconParcel className="tabs-icon" />}
                                    titleKey={this.getTabLinkTranslationKey(searchType.parcel)}
                                    descriptionKey={this.getTabLinkDescriptionTranslationKey(searchType.parcel)} hr={true}
                                />
                                <TabLink type={searchType.flatOrNonFlatArea} selected={this.state.selected} onSelect={this.selectSearch}
                                    icon={<IconFlatOrNonFlatArea className="tabs-icon" />}
                                    titleKey={this.getTabLinkTranslationKey(searchType.flatOrNonFlatArea)}
                                    descriptionKey={this.getTabLinkDescriptionTranslationKey(searchType.flatOrNonFlatArea)} hr={false}
                                />
                            </>}
                        </ul>
                    </FormMenuControl>
                </div>
                <div className="column">
                    {this.hasSearchTips(this.state.selected) &&
                        <SearchTip windowId={`tips_property_sk_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-mobile" style={{ marginBottom: '-0.5em', marginTop: '1em' }} />}
                    <div className='card card-special'>
                        {this.hasSearchTips(this.state.selected) &&
                            <SearchTip windowId={`tips_property_sk_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-desktop" style={{ marginBottom: '-2.5em', paddingTop: '1em', marginRight: '1em' }} />}
                        <div className='card-body'>
                            <div className='columns is-centered is-multiline'>
                                <div className="column is-12">
                                    {this.state.selected === searchType.owner && <PropertySkOwnerSearchForm />}
                                    {this.state.selected === searchType.ownershipDeed && <PropertySkOwnershipDeedSearchForm />}
                                    {this.state.selected === searchType.registrationNumber && <PropertySkRegistrationNumberSearchForm />}
                                    {this.state.selected === searchType.parcel && <PropertySkParcelSearchForm />}
                                    {this.state.selected === searchType.flatOrNonFlatArea && <PropertySkFlatOrNonFlatAreaSearchForm />}
                                </div>
                            </div>
                        </div >
                    </div >
                </div>
            </div >
        );
    }

    selectSearch = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({ selected: selected });
            this.props.closeAll();
        }
    }

    getTabLinkTranslationKey = (type) => {
        const prefix = "PropertySk.SearchTab.";
        switch (type) {
            case searchType.owner: return prefix + "Owner";
            case searchType.ownershipDeed: return prefix + "OwnershipDeed";
            case searchType.registrationNumber: return prefix + "RegistrationNumber";
            case searchType.parcel: return prefix + "Parcel";
            case searchType.flatOrNonFlatArea: return prefix + "FlatOrNonFlatArea";
            default: return "Unknown";
        }
    }

    getTabLinkDescriptionTranslationKey = (type) => {
        const prefix = "PropertySk.SearchTab.";
        const suffix = ".Description";
        switch (type) {
            case searchType.owner: return prefix + "Owner" + suffix;
            case searchType.ownershipDeed: return prefix + "OwnershipDeed" + suffix;
            case searchType.registrationNumber: return prefix + "RegistrationNumber" + suffix;
            case searchType.parcel: return prefix + "Parcel" + suffix;
            case searchType.flatOrNonFlatArea: return prefix + "FlatOrNonFlatArea" + suffix;
            default: return "Unknown";
        }
    }

    hasSearchTips(type) {
        switch (type) {
            case searchType.owner:
            case searchType.ownershipDeed:
            case searchType.registrationNumber:
            case searchType.parcel:
            case searchType.flatOrNonFlatArea:
                return true;
        }
        return false;
    }

    getSearchTipsModel = (type) => {
        switch (type) {
            case searchType.owner:
                return { title: `${this.props.translate('PropertySk.SearchTab.Owner')}`, bodyHtml: this.props.translate('SearchTips.PropertySK.Owner.Body') };
            case searchType.ownershipDeed:
                return { title: `${this.props.translate('PropertySk.SearchTab.OwnershipDeed')}`, bodyHtml: this.props.translate('SearchTips.PropertySK.OwnershipDeed.Body') };
            case searchType.registrationNumber:
                return { title: `${this.props.translate('PropertySk.SearchTab.RegistrationNumber')}`, bodyHtml: this.props.translate('SearchTips.PropertySK.RegistrationNumber.Body') };
            case searchType.parcel:
                return { title: `${this.props.translate('PropertySk.SearchTab.Parcel')}`, bodyHtml: this.props.translate('SearchTips.PropertySK.Parcel.Body') };
            case searchType.flatOrNonFlatArea:
                return { title: `${this.props.translate('PropertySk.SearchTab.FlatOrNonFlatArea')}`, bodyHtml: this.props.translate('SearchTips.PropertySK.FlatOrNonFlatArea.Body') };
        }
        return undefined;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.propertySk }, layout: state.layout }),
    dispatch => bindActionCreators({ ...searchActions, ...windowActions }, dispatch),
)(PropertySkSearchForm)));
